// extracted by mini-css-extract-plugin
export default {"wrapper":"DrafResume_wrapper__TUUsP","form":"DrafResume_form__t9vFP","preview":"DrafResume_preview__Uiiax"};